function indexToExpandAfterToggle({ expandedIndex, toggledIndex }) {
  if (toggledIndex === expandedIndex) {
    return -1;
  }
  return toggledIndex;
}

export default indexToExpandAfterToggle;
